import { BaseModal, Button, Input, ToastMessage } from '@cokitchen/cokitchen-components';
import useDashboardContext from 'contexts/dashboard.context';
import { DineInTableType } from 'models/dine-in-table';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import { handleApiError } from 'utils/functions';

const CreateTableModal = ({
  show,
  onClose,
  setTables,
  tables
}: {
  show: boolean;
  onClose: (success?: boolean) => void;
  setTables: (val: DineInTableType[]) => void;
  tables: DineInTableType[];
}) => {
  const [tableNumber, setTableNumber] = useState<number>();
  const [loading, setLoading] = useState(false);
  const { activeCokitchen } = useDashboardContext();

  const onConfirm = async () => {
    setLoading(true);
    try {
      const res = await apiService.post<{ data: DineInTableType; message: string }>(
        'dine-in-tables',
        {
          data: {
            number: Number(tableNumber),
            cokitchen_id: activeCokitchen.id
          }
        }
      );
      setTables([...tables, res.data.data]);
      toast(<ToastMessage type='success' message={res.data.message} />);
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <div>
      <BaseModal
        isOpen={show}
        title='Create new table'
        onRequestClose={() => onClose()}
        footer={
          <Button
            onClick={onConfirm}
            type='submit'
            color='primary'
            variant='block'
            small
            loading={loading}
            disabled={!tableNumber}>
            Generate QR code
          </Button>
        }>
        <Input
          small
          type='number'
          label='Table number'
          placeholder='e.g 1'
          onChange={(e) => setTableNumber(Number(e.target.value))}
          value={tableNumber}
          autoFocus
        />
      </BaseModal>
    </div>
  );
};

export default CreateTableModal;
